import React from "react";
import EditButton from "../../../components/EditButton";

import {
  cpf as cpfMask,
} from "../../../constants/validate";

const ReadOnlyRow = ({ contact, handleEditClick, handleDeleteClick }) => {
  return (
    <tr>
      <td>{contact.name}</td>
      <td>{cpfMask(contact.cpf)}</td>
      <td>{contact.email}</td>
      <>
        {
          contact.blocked == 0 ?
            <td>Não</td>
            :
            <td>Sim</td>
        }
      </>
      <td>
        <EditButton
          onClick={(event) => handleEditClick(event, contact)}
        >
        </EditButton>
        {/*  <button type="button" onClick={() => handleDeleteClick(contact.id)}>
          Delete
        </button> */}
      </td>
    </tr>
  );
};

export default ReadOnlyRow;
